// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContextMenu-module__disabled--UvFfP {
  opacity: 0.5;
}

.ContextMenu-module__contextMenu--WhDDO {
  display: flex;
  padding: 0.75rem 0px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  position: fixed;
  z-index: 3;
  border-radius: 8px;
  border: 1px solid var(--context-menu-border-color);
  background: var(--context-menu-background-color);
  box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(40px);
  user-select: none;
}

.ContextMenu-module__divider--kT3S_ {
  height: 1px;
  width: 100%;
  background: var(--context-menu-border-color);
}

.ContextMenu-module__optionContainer--q4XGE {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.ContextMenu-module__optionContainer--q4XGE :hover:not(.ContextMenu-module__containerHeader--pKS39) {
  background: var(--context-menu-hover-color);
}

.ContextMenu-module__containerHeader--pKS39 {
  display: flex;
  padding: 0.375rem 1rem 0.375rem 0.75rem;
  justify-content: left;
  align-items: center;
  gap: 0.625rem;
  align-self: stretch;
  flex: 1 0 0;
  color: var(--context-menu-header-color);
  font-family: "Roboto Flex";
  font-size: 0.8125rem;
  letter-spacing: 0.008125rem;
}

.ContextMenu-module__option--cTcxZ {
  display: flex;
  height: 2.25rem;
  padding: 0px 0.75rem;
  align-items: center;
  gap: 0.5rem;
  align-self: stretch;
}

.ContextMenu-module__icon--FydIB {
  height: 1rem;
  width: 1rem;
}

.ContextMenu-module__plusIcon--Hp9wv {
  height: 0.625rem;
  width: 0.5625rem;
}

.ContextMenu-module__text--G_UfU {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  flex: 1 0 0;
  overflow: hidden;
  color: var(--context-menu-text-color);
  text-overflow: ellipsis;
  font-family: "Roboto Flex";
  width: 10rem;
}

.ContextMenu-module__smallerTextArea--ihId9 {
  width: 6.1rem;
}

.ContextMenu-module__hotkey--B7q9i {
  display: flex;
  height: 2rem;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  font-family: "Roboto Flex";
  color: var(--context-menu-hotkey-color);
}`, "",{"version":3,"sources":["webpack://./src/components/ContextMenu.module.scss"],"names":[],"mappings":"AAAA;EACC,YAAA;AACD;;AAEA;EAEC,aAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EAGA,kBAAA;EACA,kDAAA;EACA,gDAAA;EACA,gDAAA;EACA,2BAAA;EAGA,iBAAA;AAJD;;AAMA;EACC,WAAA;EACA,WAAA;EACA,4CAAA;AAHD;;AAKA;EACC,aAAA;EACA,sBAAA;EACA,WAAA;AAFD;AAGC;EACC,2CAAA;AADF;;AAKA;EACC,aAAA;EACA,uCAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EAEA,uCAAA;EACA,0BAAA;EACA,oBAAA;EACA,2BAAA;AAHD;;AAMA;EACC,aAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AAHD;;AAMA;EACC,YAAA;EACA,WAAA;AAHD;;AAKA;EACC,gBAAA;EACA,gBAAA;AAFD;;AAIA;EAEC,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,WAAA;EAGA,gBAAA;EACA,qCAAA;EACA,uBAAA;EACA,0BAAA;EACA,YAAA;AAJD;;AAOA;EACC,aAAA;AAJD;;AAOA;EACC,aAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,0BAAA;EACA,uCAAA;AAJD","sourcesContent":[".disabled {\n\topacity: 0.5;\n}\n\n.contextMenu {\n\t// Layout\n\tdisplay: flex;\n\tpadding: 0.75rem 0px;\n\tflex-direction: column;\n\tjustify-content: flex-end;\n\talign-items: center;\n\tgap: 0.5rem;\n\tposition: fixed;\n\tz-index: 3;\n\n\t// Style\n\tborder-radius: 8px;\n\tborder: 1px solid var(--context-menu-border-color);\n\tbackground: var(--context-menu-background-color);\n\tbox-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.3);\n\tbackdrop-filter: blur(40px);\n\n\t// Prevent text selection in context menu\n\tuser-select: none;\n}\n.divider {\n\theight: 1px;\n\twidth: 100%;\n\tbackground: var(--context-menu-border-color);\n}\n.optionContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\t:hover:not(.containerHeader) {\n\t\tbackground: var(--context-menu-hover-color);\n\t}\n}\n\n.containerHeader {\n\tdisplay: flex;\n\tpadding: 0.375rem 1rem 0.375rem 0.75rem;\n\tjustify-content: left;\n\talign-items: center;\n\tgap: 0.625rem;\n\talign-self: stretch;\n\tflex: 1 0 0;\n\n\tcolor: var(--context-menu-header-color);\n\tfont-family: \"Roboto Flex\";\n\tfont-size: 0.8125rem; // 13px\n\tletter-spacing: 0.008125rem; // 0.13px\n}\n\n.option {\n\tdisplay: flex;\n\theight: 2.25rem;\n\tpadding: 0px 0.75rem;\n\talign-items: center;\n\tgap: 0.5rem;\n\talign-self: stretch;\n}\n\n.icon {\n\theight: 1rem;\n\twidth: 1rem;\n}\n.plusIcon {\n\theight: 0.625rem;\n\twidth: 0.5625rem;\n}\n.text {\n\t// Display\n\tdisplay: -webkit-box;\n\t-webkit-box-orient: vertical;\n\t-webkit-line-clamp: 1;\n\tflex: 1 0 0;\n\n\t// Typography\n\toverflow: hidden;\n\tcolor: var(--context-menu-text-color);\n\ttext-overflow: ellipsis;\n\tfont-family: \"Roboto Flex\";\n\twidth: 10rem;\n}\n\n.smallerTextArea {\n\twidth: 6.1rem;\n}\n\n.hotkey {\n\tdisplay: flex;\n\theight: 2rem;\n\tpadding: 0.5rem;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 0.25rem;\n\tfont-family: \"Roboto Flex\";\n\tcolor: var(--context-menu-hotkey-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"disabled": `ContextMenu-module__disabled--UvFfP`,
	"contextMenu": `ContextMenu-module__contextMenu--WhDDO`,
	"divider": `ContextMenu-module__divider--kT3S_`,
	"optionContainer": `ContextMenu-module__optionContainer--q4XGE`,
	"containerHeader": `ContextMenu-module__containerHeader--pKS39`,
	"option": `ContextMenu-module__option--cTcxZ`,
	"icon": `ContextMenu-module__icon--FydIB`,
	"plusIcon": `ContextMenu-module__plusIcon--Hp9wv`,
	"text": `ContextMenu-module__text--G_UfU`,
	"smallerTextArea": `ContextMenu-module__smallerTextArea--ihId9`,
	"hotkey": `ContextMenu-module__hotkey--B7q9i`
};
export default ___CSS_LOADER_EXPORT___;
